/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetKillmailsKillmailIdKillmailHashItemsItem } from './GetKillmailsKillmailIdKillmailHashItemsItem';
import {
    GetKillmailsKillmailIdKillmailHashItemsItemFromJSON,
    GetKillmailsKillmailIdKillmailHashItemsItemFromJSONTyped,
    GetKillmailsKillmailIdKillmailHashItemsItemToJSON,
    GetKillmailsKillmailIdKillmailHashItemsItemToJSONTyped,
} from './GetKillmailsKillmailIdKillmailHashItemsItem';

/**
 * item object
 * @export
 * @interface GetKillmailsKillmailIdKillmailHashItem
 */
export interface GetKillmailsKillmailIdKillmailHashItem {
    /**
     * Flag for the location of the item
     * 
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItem
     */
    flag: number;
    /**
     * item_type_id integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItem
     */
    itemTypeId: number;
    /**
     * items array
     * @type {Array<GetKillmailsKillmailIdKillmailHashItemsItem>}
     * @memberof GetKillmailsKillmailIdKillmailHashItem
     */
    items?: Array<GetKillmailsKillmailIdKillmailHashItemsItem>;
    /**
     * How many of the item were destroyed if any
     * 
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItem
     */
    quantityDestroyed?: number;
    /**
     * How many of the item were dropped if any
     * 
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItem
     */
    quantityDropped?: number;
    /**
     * singleton integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItem
     */
    singleton: number;
}

/**
 * Check if a given object implements the GetKillmailsKillmailIdKillmailHashItem interface.
 */
export function instanceOfGetKillmailsKillmailIdKillmailHashItem(value: object): value is GetKillmailsKillmailIdKillmailHashItem {
    if (!('flag' in value) || value['flag'] === undefined) return false;
    if (!('itemTypeId' in value) || value['itemTypeId'] === undefined) return false;
    if (!('singleton' in value) || value['singleton'] === undefined) return false;
    return true;
}

export function GetKillmailsKillmailIdKillmailHashItemFromJSON(json: any): GetKillmailsKillmailIdKillmailHashItem {
    return GetKillmailsKillmailIdKillmailHashItemFromJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKillmailsKillmailIdKillmailHashItem {
    if (json == null) {
        return json;
    }
    return {
        
        'flag': json['flag'],
        'itemTypeId': json['item_type_id'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetKillmailsKillmailIdKillmailHashItemsItemFromJSON)),
        'quantityDestroyed': json['quantity_destroyed'] == null ? undefined : json['quantity_destroyed'],
        'quantityDropped': json['quantity_dropped'] == null ? undefined : json['quantity_dropped'],
        'singleton': json['singleton'],
    };
}

export function GetKillmailsKillmailIdKillmailHashItemToJSON(json: any): GetKillmailsKillmailIdKillmailHashItem {
    return GetKillmailsKillmailIdKillmailHashItemToJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashItemToJSONTyped(value?: GetKillmailsKillmailIdKillmailHashItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flag': value['flag'],
        'item_type_id': value['itemTypeId'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetKillmailsKillmailIdKillmailHashItemsItemToJSON)),
        'quantity_destroyed': value['quantityDestroyed'],
        'quantity_dropped': value['quantityDropped'],
        'singleton': value['singleton'],
    };
}

